import { IActionContext } from '@msdyn365-commerce/core';
import { CustomerAttribute } from '@msdyn365-commerce/retail-proxy';

import { mttGetOrganizationAttributesAsync } from '../proxy/DataActionExtension.g';

/**
 * Gets organization customer attributes via MTTGetOrganizationAttributes Retail Server API.
 * Customer id is resolved from the auth token on the server side.
 */
export async function getOrganizationAttributesAction(ctx: IActionContext): Promise<CustomerAttribute[]> {
    try {
        const attributes = await mttGetOrganizationAttributesAsync({ callerContext: ctx });
        return attributes ?? [];
    } catch (error) {
        ctx.telemetry.exception(error as Error);
        ctx.telemetry.debug('[getOrganizationAttributesAction] Failed to get organization attributes');
        return [];
    }
}
